/**
 * @name routes.js
 * @module app
 *
 * @description
 * The typescript app components.
 *
 * @project spotgig4web
 * @author Ryunosuke Oguri on 2017/07/28
 * Copyright © 2017年 Axis-motion. All rights reserved.
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import PageNotFound from './viewModels/PageNotFound.vue'

import Home from './viewModels/sessions/Home.vue'
import Signup from './viewModels/sessions/signup/Template.vue'

import Privacy from './viewModels/staticPages/Privacy.vue'
import Contract from './viewModels/staticPages/Contract.vue'
import SignupFlow from './viewModels/staticPages/SignupFlow.vue'
import StoreRedirect from './viewModels/StoreRedirect.vue'
import SIGNUP_ROUTES from "@/constants/signupRoutes";
import SessionExpired from "@/viewModels/sessions/signup/SessionExpired";

const router = new VueRouter({
  mode: 'history',
  base: '/',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    { path: '/', name: 'home', components: { sessions: Home } },
    { path: '*', name: '404', components: { sessions: PageNotFound }, meta: { title: 'NotFound' } },
    { path: '/404_page', name: 'pageNotFound', components: { sessions: PageNotFound }, meta: { title: 'NotFound' } },
    { path: '/signup', components: { sessions: Signup }, children: SIGNUP_ROUTES },
    { path: '/privacy', name: 'privacy', components: { sessions: Privacy }, meta: { title: 'プライバシーポリシー' } },
    { path: '/contract', name: 'contract', components: { sessions: Contract }, meta: { title: '業務委託について' } },
    { path: '/Signup/flow', name: 'signupFlow', components: { sessions: SignupFlow }, meta: { title: '会員登録の流れ' } },
    { path: '/scout', name: 'scout', components: { sessions: StoreRedirect }, meta: { title: 'スカウト' } },
    { path: '/sessionExpired', name: 'sessionExpired', components: { sessions: SessionExpired } }
  ]
});

router.beforeEach((to, from, next) => {
  const title = to.meta.title;
  document.title = title != null ? `${title} - gigbase app` : 'gigbase app';
  next();
});

export default router
